/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs';

const GlobalOmitAttributes = ['createdAt', 'updatedAt'];

const OmitAttributes: {[key: string]: Array<string>} = {
  'Event': ['competitors', 'entries', 'subEvents', 'settings', 'controls', 'maps', 'routes'],
  'Entry': ['createdAt', 'userName'],
  'Map': ['createdAt'],
  'EventMap': ['createdAt'],
  'Route': ['createdAt'],
  'Competitor': ['device', 'user', 'hasTrack'],
  'EventCompetitor': ['device', 'user', 'hasTrack', 'subEvent'],
  'Device': ['last', 'battery'],
  'Group': ['groupUsers']
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformDatesAndOmitRelated = (record: any, resource: string) => {
  const newRecord = {...record};
  if (!record) {
    return record;
  }
  for (const key of Object.keys(record)) {
    if ((key.includes('Date') || key.includes('Time')) && typeof record[key] === 'string') {
      newRecord[key] = dayjs(record[key]);
    }
    if (
      GlobalOmitAttributes.includes(key) ||
      (OmitAttributes[resource] && Array.isArray(OmitAttributes[resource]) && OmitAttributes[resource].includes(key))
    ) {
      delete newRecord[key];
    }
  }
  return newRecord;
};

export const escapeCsvValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  }
  const str = typeof value === 'object' ? JSON.stringify(value) : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const recordsToCsv = (records: Array<Record<string, unknown>>): string => {
  if (!records.length) {
    return '';
  }
  const headers = [...new Set(records.flatMap((record) => Object.keys(record)))];
  const lines = [
    headers.join(','),
    ...records.map((record) => headers.map((header) => escapeCsvValue(record[header])).join(','))
  ];
  return lines.join('\n');
};

export const downloadCSV = (csv: string, filename: string): void => {
  const fakeLink = document.createElement('a');
  fakeLink.style.display = 'none';
  document.body.appendChild(fakeLink);
  const blob = new Blob([csv], {type: 'text/csv;charset=utf-8'});
  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(blob, `${filename}.csv`);
  } else {
    fakeLink.setAttribute('href', URL.createObjectURL(blob));
    fakeLink.setAttribute('download', `${filename}.csv`);
    fakeLink.click();
  }
};
